// Simple analytics API layer
const API = process.env.REACT_APP_API_URL || "";

function getToken() {
  try {
    return JSON.parse(localStorage.getItem("user"))?.accessToken || "";
  } catch {
    return "";
  }
}

async function apiGet(path, params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${API}${path}${qs ? `?${qs}` : ""}`, {
    headers: { accessToken: getToken() }
  });
  if (!res.ok) {
    let text;
    try { text = await res.text(); } catch { text = res.statusText; }
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function fetchAccounts() {
  const data = await apiGet('/analytics/accounts');
  // backend returns { accounts: [...], moderatorOrg: boolean }
  return { accounts: data.accounts || [], moderatorOrg: !!data.moderatorOrg };
}

export async function fetchSummary(params) {
  if (typeof params === 'string') return apiGet('/analytics/account-summary', { ig_id: params });
  const { ig_id, ig_ids, aggregate } = params;
  const query = {};
  if (ig_ids) query.ig_ids = ig_ids.join(',');
  if (ig_id) query.ig_id = ig_id; // fallback
  if (aggregate) query.aggregate = 1;
  return apiGet('/analytics/account-summary', query);
}

export async function fetchSnapshots({ ig_id, ig_ids, metric, from, to, fill = true, aggregate = false }) {
  const query = { metric, from, to, fill };
  if (ig_ids) query.ig_ids = ig_ids.join(','); else if (ig_id) query.ig_id = ig_id;
  if (aggregate) query.aggregate = 1;
  return apiGet('/analytics/account-snapshots', query);
}

export async function fetchRecentMedia({ ig_id, ig_ids, to, from, aggregate = false }) {
  const query = {};
  if (to) query.to = to;
  if (from) query.from = from;
  if (ig_ids) query.ig_ids = ig_ids.join(','); else if (ig_id) query.ig_id = ig_id;
  if (aggregate) query.aggregate = 1;
  return apiGet('/analytics/recent-media', query);
}

export async function fetchLiveMediaInsights({ media_id, period }) {
  // Используем общий клиент с заголовком accessToken
  const params = { media_id };
  if (period) params.period = period;
  return apiGet('/analytics/live-insights', params);
}

export async function fetchMediaSnapshotsSeries({ media_id, from, to }) {
  // Используем общий клиент с заголовком accessToken
  const params = { media_id };
  if (from) params.from = from;
  if (to) params.to = to;
  return apiGet('/analytics/media-snapshots', params);
}

 export async function ensureAccountToday(ig_id){
  return apiGet('/analytics/ensure-account-today', { ig_id });
}

export const analyticsApi = { fetchAccounts, fetchSummary, fetchSnapshots, fetchRecentMedia, fetchLiveMediaInsights, fetchMediaSnapshotsSeries, ensureAccountToday };
